import React, { useState, useEffect } from "react";
import { Routes } from "../../constants";
import { Link, useNavigate } from "react-router-dom";
import ContentCard from "./ContentCard";
import { useLocation } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const CreateVideoSop = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const video_session_id = location.state;
  const [refreshLoader, setRefreshLoader] = useState(false);
  const [data, setData] = useState([]);

  const [cards, setCards] = useState([
    {
      id: "1",
      prompt: "", 
      startPrompt: "", 
      endPrompt: "", 
      status: "",
      videoId: "",
      video_status: "",
      isChecked: false,
      videoDownload: "",
      generatedItems: [],
    },
  ]);

  const addCard = (afterId) => {
    const newCard = {
      id: Date.now().toString(),
      prompt: "",
      startPrompt: "",
      endPrompt: "",
      status: "",
      videoId: "",
      video_status: "",
      isChecked: false,
      videoDownload: "",
      generatedItems: [],
    };

    if (afterId) {
      const index = cards.findIndex((card) => card.id === afterId);
      const newCards = [...cards];
      newCards.splice(index + 1, 0, newCard);
      setCards(newCards);
    } else {
      setCards([...cards, newCard]);
    }
  };

  const removeCard = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (cards.length <= 1) return;

        try {
          // Call delete API here
          const response = await props.admin.deleteVideoInput(id ,video_session_id);

          if (response.success) {
            // Remove the card from state
            setCards(cards.filter((card) => card.id !== id));
            toast.success("Video card deleted successfully!", {
              position: toast.POSITION.TOP_CENTER,
            });
          } else if (response.status === 404) {
            setCards(cards.filter((card) => card.id !== id));

            toast.success("Video card deleted successfully", {
              position: toast.POSITION.TOP_CENTER,
            });
          } else {
            throw new Error(response.message || "Delete failed");
          }
        } catch (error) {
          console.error("Failed to delete video input:", error);
          toast.error("Failed to delete video input. Please try again.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };

  const updateCard = (id, updates) => {
    setCards(
      cards.map((card) => (card.id === id ? { ...card, ...updates } : card))
    );
  };
  useEffect(() => {
    getList();
  }, []);
  const getList = async () => {
    try {
      const response = await props.admin.fetchListImageScript(video_session_id);
      props.application.setLoading(true);

      if (response.success === true && Array.isArray(response.data)) {
        const newCards = response.data.map((entry) => {
          const generatedItems = entry.scripts.map((script, index) => ({
            id: `${script.id}`,
            prompt: entry.user_text,
            image: script.image_url,
            script: script.video_script,
            imageDownload: script.image_download_url,
            videoDownload: entry.video_download_url,
            video: entry.merged_video || "", // optional, if available
          }));

          return {
            id: entry.input_id.toString(), // use input_id as card ID
            prompt: entry.user_text,
            startPrompt: entry.start,
            isChecked: false,
            endPrompt: entry.end,
            video: entry.merged_video || null,
            status: entry.generate_status,
            video_status: entry.video_status,
            videoId: entry.video_id,
            isChecked: entry.end_status,
            videoDownload: entry.video_download_url,
            generatedItems,
          };
        });

        // Replace all cards
        setCards(newCards);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch the list:", error);
      toast.dismiss();
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
    }
  };
  const getCardData = async (videoInputId) => {
    try {
      const response = await props.admin.getOneVideocard(
        video_session_id,
        videoInputId
      );

      if (response.success === true && response.data) {
        const entry = response.data; // assuming only one card
        if (!entry) return;

        const generatedItems = entry.scripts.map((script) => ({
          id: `${script.id}`,
          prompt: entry.user_text,
          image: script.image_url,
          script: script.video_script,
          imageDownload: script.image_download_url,
          videoDownload: entry.video_download_url,
          video: entry.merged_video || "",
        }));

        const newCard = {
          id: entry.input_id.toString(),
          prompt: entry.user_text,
          startPrompt: entry.start,
          endPrompt: entry.end,
          video: entry.merged_video || null,
          status: entry.generate_status,
          video_status: entry.video_status,
          isChecked: entry.end_status,
          videoId: entry.video_id,
          videoDownload: entry.video_download_url,
          generatedItems,
        };
        // setData(response?.data);
        // updateCard(id,newCard)
        const id = localStorage.getItem("cardId");
        if (id) {
          setCards((prevCards) => {
            const index = prevCards.findIndex((card) => card.id === id);
            if (index !== -1) {
              const updated = [...prevCards];
              updated[index] = newCard;
              localStorage.removeItem("cardId");
              return updated;
            }
            return prevCards; // Don't add new card
          });
        } else {
          setCards((prevCards) => {
            const index = prevCards.findIndex((card) => card.id === newCard.id);
            if (index !== -1) {
              const updated = [...prevCards];
              updated[index] = newCard;
              localStorage.removeItem("cardId");
              return updated;
            }
            return prevCards; // Don't add new card
          });
        }
      }
    } catch (error) {
      console.error("Failed to fetch the card:", error);
      toast.dismiss();
      toast.error("Something went wrong while fetching the card.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const handleGoToMerge = async () => {
    const payload = {
      session_id: video_session_id,
      videos: cards
        .filter((item) => item.videoId !== null)
        .map((item) => ({
          type: "generated",
          id: item.videoId,
        })),
    };

    try {
      const res = await props.admin.createMerge(payload);
      if (res.success) {
        // toast.dismiss();
        // toast.success(res.message || "Videos submitted successfully!", {
        //   position: "top-center",
        // });
        navigate(Routes.MERGE_VIDEO, {
          state: { video_session_id: video_session_id, cards: cards },
        });
        // await fetchVideos();
        //  setSelectedVideos([]);
      } else {
        toast.dismiss();
        toast.success(res.message || "Something went wrong!", {
          position: "top-center",
        });
      }
    } catch (error) {
      console.error("Error submitting videos:", error);
      toast.error("Failed to submit videos. Please try again.", {
        position: "top-center",
      });
    }
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle mb-3">
        <h1>Generate Video </h1>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={Routes.VIDEO}>Video managment</Link>
            </li>
            <li className="breadcrumb-item active">Generate Video </li>
          </ol>
        </nav>
      </div>
      <section className="section dashboard">
        <div className="row">
          <div className="col-12">
            <div className="card recent-sales overflow-auto">
              <div className="card-body p-3">
                <div className="data-se">
                  <section className="section dashboard">
                    <div className="row ">
                      <div className="mergerow">
                        {cards.some(
                          (card) => card.videoId && card.videoId !== null
                        ) && (
                          <button
                            className="btn btn-primary m-0"
                            onClick={handleGoToMerge}
                          >
                            Go to video merge
                          </button>
                        )}
                        &nbsp;
                        <Link to={Routes.VIDEO} className="btn btn-primary">
                          Back
                        </Link>
                        &nbsp;
                        <button
                          className="btn btn-primary "
                          onClick={async () => {
                            setRefreshLoader(true);
                            await getList();
                            setTimeout(async () => {
                              setRefreshLoader(false);
                            }, 1000);
                          }}
                          title="Refresh the page"
                        >
                          {" "}
                          {refreshLoader ? (
                            <>
                              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                            </>
                          ) : (
                            <>
                              <i className="fa-solid fa-rotate-right"></i>
                            </>
                          )}
                        </button>
                      </div>
                      <div className="col-12">
                        {cards.map((card, index) => (
                          <ContentCard
                            card={card}
                            onUpdate={(updates) => updateCard(card.id, updates)}
                            onRemove={() => removeCard(card.id)}
                            canRemove={cards.length > 1}
                            onClick={() => addCard(card.id)}
                            videoSessionId={video_session_id}
                            props={props}
                            getList={getList}
                            getCardData={getCardData}
                          />
                        ))}
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
export default injectModels(["admin", "application", "application"])(
  CreateVideoSop
);
